// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 178 ? "320c792b" : chunkId) + "." + {"178":"5b05a4f0936872bf","297":"6f8c7a3e6daaddd4"}[chunkId] + ".js";
};